import { format as d3Format, timeFormat } from 'd3';

export type TimeScaleMode = 'numeric' | 'time';

const tooltipDateFormat = timeFormat('%b %d, %Y');

/**
 * Format a datum value for tooltips/labels according to the resolved time
 * scale mode and the `data.valueFormat` schema option.
 */
export function formatValue(value: number, mode: TimeScaleMode, valueFormat: string): string {
  if (mode === 'time') {
    return tooltipDateFormat(new Date(value));
  }
  switch (valueFormat) {
    case 'compact':
      return d3Format('.2~s')(value);
    case 'percent':
      return d3Format('.1%')(value);
    default:
      return d3Format(',')(value);
  }
}
